module.exports = __webpack_public_path__ + "img/61.bd314bce.jpg";